<template>
  <div class="modal-wrapper">
    <div class="modal">
      <span class="toggle close" @click="close()">
        <img src="/static/img/x.svg" alt="x" />
      </span>
      <template v-if="photos">
        <span class="toggle prev" @click="prev()">
          <img src="/static/img/prev.svg" alt="x" />
        </span>
        <span class="toggle next" @click="next()">
          <img src="/static/img/next.svg" alt="x" />
        </span>
      </template>
      <div class="youtube-video" v-if="video">
        <iframe
          :src="video"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
      <div
        class="photos"
        v-else-if="photos"
        :style="{ backgroundImage: `url(${photos.images[active]})` }"
        @click="next()"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['video', 'photos'],
  data() {
    return {
      active: 0
    };
  },
  methods: {
    close() {
      this.$parent.$emit('close-modal');
    },
    prev() {
      if (this.active > 0) {
        this.active--;
      } else {
        this.active = this.photos.images.length - 1;
      }
    },
    next() {
      if (this.active < this.photos.images.length - 1) {
        this.active++;
      } else {
        this.active = 0;
      }
    }
  }
};
</script>

<style scoped>
.modal-wrapper {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.6);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
}
.modal {
  background-color: #e9e9e9;
  box-shadow: 0px 60px 80px #0000004d;
  display: flex;
  height: 80vh;
  padding: 25px 25px;
  position: relative;
  width: 80vw;
}
.toggle {
  cursor: pointer;
  display: flex;
  padding: 5px;
  position: absolute;
}
.toggle img {
  width: 12px;
  height: 12px;
}
.close {
  right: 10px;
  top: 10px;
}
.prev {
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
}
.next {
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}
.toggle:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.youtube-video {
  border-radius: 10px;
  height: 100%;
  overflow: hidden;
  width: 100%;
}
.youtube-video iframe {
  height: 100%;
  width: 100%;
}
.photos {
  background-color: #000;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
}
@media screen and (max-width: 800px) {
  .modal {
    height: 50vh;
    width: 90vw;
  }
} 
@media screen and (max-width: 600px) {
  .modal {
    height: 40vh;
    width: 90vw;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/shared/Modal.vue